import { useEffect } from 'react';
import { handleSignout } from '../fetchHooks/handleSignout';

const Signout = () => {
  useEffect(() => {
    const performSignout = async () => {
      try {
        await handleSignout();
        // Redirect to home page after successful signout
        window.location.href = '/';
      } catch (error) {
        console.error('Signout failed:', error);
        // Still redirect even if signout fails
        window.location.href = '/';
      }
    };

    performSignout();
  }, []);

  return <h1>Signing out...</h1>;
};

export default Signout;
